import { graphql } from "src/graphql/generated";

export const onExportJobUpdateSubscription = graphql(/* GraphQL */ `
    subscription OnExportJobUpdate($jobId: String!) {
        onExportJobUpdate(jobId: $jobId) {
            jobId
            job {
                id
                state
                startedAt
                finishedAt
                downloadUrl
            }
        }
    }
`);
